import React, { useEffect, ReactNode } from "react";
import "./Button.css";
import JelloProvider from "../JelloProvider/JelloProvider";

interface ButtonProps {
  text: string;
  onClick?: () => void;
  variant?: "primary" | "secondary";
  type?: "button" | "submit" | "reset";
  children?: ReactNode;
  disabled?: boolean;
  className?: string;
}

function Button({
  text,
  onClick,
  variant = "primary",
  type = "button",
  children,
  disabled = false,
  className = "",
}: ButtonProps) {
  return (
    <div className={`button-wrapper ${className}`.trim()}>
      <button
        className={`cta ${variant}`}
        onClick={onClick}
        type={type}
        disabled={disabled}
      >
        {text}
        {children}
      </button>
    </div>
  );
}

export default Button;
